import axios from '@/util/axios'
import debug from '@/util/debug'

const fnm = 'api/processorpv.js'
const URL = process.env.VUE_APP_ROOT_API + '/prpv/api/v1/processo'

export default {

    validarNumeroProcesso: (numeroProcesso) => {
      debug(null, 'validarNumeroProcesso', fnm)
      return axios.get(`${URL}/validar/numero/${numeroProcesso}`)
    }
}
